/* Sample function that returns boolean wether the browser is Internet Explorer or not */
function isInternetExplorer(){
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
}

export default isInternetExplorer;